import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const PickingBatchListDetailTemplate = ({ store, store: { tableData, data, noDataItem, change, loading } }) => {
	if (loading) return null;
	return (
		<React.Fragment>
			<BaasicTable
				{...{
					tableData,
					store,
					noDataItem,
					change,
				}}
				data={data.slice()}
			/>
		</React.Fragment>
	);
};
export default defaultTemplate(PickingBatchListDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/picking-batch/pages/PickingBatchListDetailTemplate.jsx